<template>
  <div class="g-content">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <div class="search">
          <a-form-model
            :model="searchForm"
            layout="inline"
            ref="formElement"
            style="display:flex;align-items: center;"
          >
            <!-- 关键字 -->
            <a-form-model-item :label="null" prop="keyword">
              <a-input-search
                v-model="searchForm.keyword"
                style="min-width:200px"
                :placeholder="$t('com_form_keyword_input')"
                allowClear
                @search="getList()"
              />
            </a-form-model-item>

            <!-- 排序 -->
            <a-form-model-item :label="null" prop="orderField">
              <a-select
                v-model="searchForm.orderField"
                :placeholder="$t('com_form_order_field')"
                style="min-width:130px;"
                allowClear
                @change="getList()"
              >
                <!-- 默认创建时间 -->
                <a-select-option :value="2">
                  {{ $t('customer_form_order_2') }}
                </a-select-option>
                <a-select-option :value="1">
                  {{ $t('customer_form_order_1') }}
                </a-select-option>
                <a-select-option :value="3">
                  {{ $t('customer_form_order_3') }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 排序 -->
            <a-form-model-item :label="null" prop="orderType">
              <a-select
                v-model="searchForm.orderType"
                placeholder="Order Type"
                style="min-width:130px;"
                show-search
                allowClear
                @change="getList()"
              >
                <a-select-option :value="1">
                  {{ $t('com_form_order_desc') }}
                </a-select-option>
                <a-select-option :value="0">
                  {{ $t('com_form_order_esc') }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 提交 -->
            <a-form-model-item style="margin:0">
              <a-button type="primary" @click.prevent="getList()" style="margin-right:10px;">
                {{ $t('com_btn_search') }}
              </a-button>

              <a-button @click="onSearchReset">
                {{ $t('com_btn_reset') }}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>

        <a-button
          type="primary"
          style="margin-left:15px;"
          @click="showUpdate()"
          icon="plus"
          v-auth="['auth_customer_add']"
        >
          {{ $t('customer_btn_add') }}
        </a-button>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="g-table">
        <Loading :show="true" v-if="loading" />
        <NetworkError v-else-if="networkError" style="margin-top:0;" />
        <a-table
          :columns="columns"
          :data-source="list"
          bordered
          :rowKey="(_text, index) => index"
          :pagination="false"
          :loading="tableLoading"
          v-else
        >
          <!-- 名称  -->
          <template slot="name" slot-scope="text, record">
            <router-link
              :to="`/manage/system/customer/detail/${record.customerId}`"
              v-if="authList.includes('auth_customer_detail') || isSuperAdmin"
            >
              {{ text }}
            </router-link>

            <span v-else>{{ text }}</span>
          </template>

          <!-- 注册时间  -->
          <template slot="createTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 操作栏 -->
          <template slot="Action" slot-scope="text, record">
            <!-- <router-link
            :to="`/manage/system/customer/detail/${record.customerId}`"
            v-auth="['auth_customer_detail']"
          >
            <a-button type="enable">
              {{ $t('com_btn_detail') }}
            </a-button>
          </router-link> -->

            <a-button type="primary" @click="showUpdate(record)" v-auth="['auth_customer_edit']">
              {{ $t('com_btn_edit') }}
            </a-button>

            <a-button
              type="danger"
              @click="deleteCustomer(record)"
              v-auth="['auth_customer_delete']"
              v-if="!record.root"
            >
              {{ $t('com_btn_delete') }}
            </a-button>
          </template>
        </a-table>

        <Pagination
          :current="pagination.current"
          :total="pagination.total"
          :pageSize.sync="pagination.pageSize"
          :callback="getList"
          @change="getList"
        />
      </div>
    </div>

    <!-- 编辑/添加 Customer -->
    <Update ref="customerUpdate" :callback="getList" />
  </div>
</template>
<script>
import * as API from '@/api/system/customer';
import Update from './update.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Update,
  },

  data() {
    return {
      loading: true,
      tableLoading: false,
      // 搜索
      searchForm: {
        keyword: '',
        orderField: 2,
        orderType: 0,
      },

      list: [],
      columns: [
        {
          title: '#',
          align: 'center',
          customRender: (_text, _record, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
          align: 'left',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: this.$t('customer_table_site_created'),
          dataIndex: 'stationTotal',
          align: 'center',
        },

        {
          title: this.$t('customer_table_user'),
          dataIndex: 'userTotal',
          align: 'center',
        },

        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
      ],

      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,
      },

      networkError: false,
    };
  },

  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },

  created() {
    // 权限操作
    if (
      this.authList.includes('auth_customer_detail') ||
      this.authList.includes('auth_customer_delete') ||
      this.authList.includes('auth_customer_edit') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        width: 300,
        scopedSlots: { customRender: 'Action' },
      });
    }

    this.getList();
  },
  methods: {
    // 重置表单
    onSearchReset() {
      this.$refs.formElement.resetFields();
      this.getList();
    },

    getList(pageNo) {
      this.pagination.current = pageNo || 1;
      const params = {
        ...this.searchForm,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      this.tableLoading = true;
      this.networkError = false;
      // 获取列表
      API.CustomerList(params)
        .then(res => {
          this.list = res.data || [];

          // total
          this.pagination.total = res.totalCount;
        })
        .catch(() => {
          this.networkError = true;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
          this.loading = false;
          this.tableLoading = false;
        });
    },

    // 编辑/添加
    showUpdate(record) {
      this.$refs.customerUpdate.show(record ? record.customerId : null);
    },

    // 删除model
    deleteCustomer(record) {
      const _this = this;
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('customer_confirm_delete_title'),
        content: h('div', {}, [
          h('p', this.$t('customer_confirm_delete_content', { name: record.name })),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));

          API.CustomerDelete({ customerId: record.customerId })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.logs-nav {
  a {
    margin-right: 15px;
    color: #666;
    font-size: 12px;

    &.router-link-active {
      color: #1838d9;
      font-weight: bold;
    }
  }
}
</style>
